import axios from '../utils/request'
// 获取分类
export const doctor = () => axios.get('doc/medList')
// 获取文档类型
export const doctype = () => axios.get('doc/fileTypeList')
